
export default function(
    slotScene,
    parent,
    $ticker,
)
{
    const space = parent.child( "freegames" );
    
    $ticker.subscribe(dt => {
        // WARNING!!!если это та же сцена что и слотовая - нужно чтобы в слотовой не вызывался ticker пока идут фригеймы
    });
    
    const $winFlowUp = space.s( "winFlowUp" );
    slotScene.setWinFlowCallback( win => $winFlowUp.next( win ) );
    
    // фригеймы как таковые начались
    space.s( "start" ).subscribe( stageMath => {
        /*// предположим что нужно где-то отобразить счетчик фригеймов или еще что-то
        scene.startFreeGames(totalFreeGames);*/
        slotScene.switchToFreeGames(stageMath, () => {});
    });
    
    // фригеймы как таковые закончились
    space.s( "end" ).subscribe( stageMath => {
        slotScene.switchToMainGame(stageMath, () => {space.s( "tableHidden" ).next();});
    });
    
    //
    space.s( "freespin" ).subscribe(info => {
        //scene.onFreeSpin(info.currentFreeSpin, info.totalFreeSpins)
        // console.log('RX: FREE SPEEN');
    });
    
    //outs when $begin completes - expect receiving $spinStart:
    const $beginComplete = space.s( "beginComplete" );
    //hide freegames announcement and become ready to start spinning:
    // клинент готов начать игры
    space.s( "begin" ).subscribe( () => {
        slotScene.hideFreeGamesTable( () => $beginComplete.next());
    });
    
    const $endingComplete = space.s( "endingComplete" );
    //last freespin completes - time to display resulting table or something:
    space.s( "ending" ).subscribe( ({ math, bet, totalWin }) => {
        slotScene.showFreeGamesFinishTable(
            math,
            bet.lines,
            bet.multiplier,
            () => $endingComplete.next(),
            totalWin
        );
    });
    
    
    space.s( "spinStart" ).subscribe( ({ freespinNumber, freespinsCount, math:stageMath, server, restore }) => slotScene.freeStartSpin( freespinNumber, freespinsCount, stageMath, server, restore ) );
    space.s( "spinStart" ).map(() => 0).to($winFlowUp);

    //barrel completely stops (last reel stops):
    space.s( "spinStop" ).subscribe( spin => slotScene.freeBarrelDidStop( spin ) );
    
    space.s( "reelStop" ).subscribe( reel => slotScene.reelStopHandler && slotScene.reelStopHandler(reel, true) );
    
    const $showComplete = space.s( "showComplete" );
    const $winShowDelayed = space.s( "winShowDelayed" );
    $winShowDelayed
        .delay( 2000 )
        .on( () => slotScene.hideFreeGamesTable( () => $showComplete.next() ) );
    space.s( "showWin" ).subscribe( info => {
        if (info.math.freeGamesCountIncrease) {
            slotScene.freeShowWinBeforeFreeGames( info, () => $winShowDelayed.next() );
        }
        else {
            slotScene.freeShowWin(
                info,
                () => $showComplete.next(),
            );
        }
    });
    
    space.s( "noFreeWin" ).subscribe( info => {
        slotScene.noFreeWin(
            info,
            () => $showComplete.next(),
        );
    });
    
    space.s( "interruptWinShow" ).subscribe(() => {
        slotScene.interruptShowWin();
    });
    
    return {
        ui:slotScene,
        space,
    };
}




// WEBPACK FOOTER //
// ./src/library/freegames_view.es6